import Widget from './component'

export default Widget
